import { Button, Typography } from '@material-ui/core';
import { Backdrop } from '@room-match/shared-ui-components';
import { FrontLayout } from 'components';
import { parse } from 'query-string';
import { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { agencyService } from 'shared/services/agencyService';
import { ls } from 'shared/utils/ls';
import { useStyles } from './AgencyRegistration.styles';
import PasswordField from './PasswordField';

const { getCompany } = agencyService();
const AgencyRegistration = () => {
  const { setLS } = ls();
  const classes = useStyles();
  const { agency } = useParams() as {
    agency: string;
  };

  const { data: companyData, isLoading: isLoadingCompany } = getCompany(agency);
  const [fromStorage, setFromStorage] = useState({
    token: '',
    profileId: '',
    stageFirstName: '',
    stageLastName: '',
    stageName: '',
  });

  const history = useHistory();

  const getCompanyDetails = useMemo(() => {
    return companyData ? companyData.data.attributes : undefined;
  }, [companyData]);

  const handleClick = () => {
    history.push(ROUTES.SIGNUP);
  };

  useEffect(() => {
    if (companyData === undefined && !isLoadingCompany) return history.push('/login');
    setLS(
      'agency',
      JSON.stringify({
        name: getCompanyDetails?.full_name,
        slug: getCompanyDetails?.slug,
        id: getCompanyDetails?.id,
        resetToken: fromStorage.token,
        profileId: fromStorage.profileId,
        stageFirstName: fromStorage.stageFirstName,
        stageLastName: fromStorage.stageLastName,
        stageName: fromStorage.stageName,
        country: getCompanyDetails?.country,
      }),
    );
  }, [companyData, isLoadingCompany]);

  useEffect(() => {
    const queryParams = location.search;
    if (queryParams) {
      const token = parse(queryParams)?.reset_password_token as string;
      const profileId = parse(queryParams)?.profile_id as string;
      const stageFirstName = parse(queryParams)?.stage_first_name as string;
      const stageLastName = parse(queryParams)?.stage_last_name as string;
      const stageName = `${stageFirstName} ${stageLastName}`;
      if (token) {
        setFromStorage({ token, profileId, stageFirstName, stageLastName, stageName });
      }
    }
  }, []);

  if (isLoadingCompany) return <Backdrop isLoading={true} />;

  return fromStorage.token ? (
    <FrontLayout
      newTalent
      heading="Register"
      subHeading="Let’s get started by setting up your password"
      containerWidth={480}
      type="register"
    >
      <PasswordField token={fromStorage.token} />
    </FrontLayout>
  ) : (
    <FrontLayout containerWidth={1000}>
      <div className={classes.mainCont}>
        {getCompanyDetails?.logo ? (
          <img src={`${getCompanyDetails?.logo}`} className={classes.agencyLogo} />
        ) : (
          <div className={classes.logoPlaceholder}>{getCompanyDetails?.full_name}</div>
        )}
        <Typography style={{ fontSize: 24, margin: 20 }}>Create a Casting.com Profile</Typography>
        <Typography className={classes.welcomeMessage}>{getCompanyDetails?.welcome_message}</Typography>
        <Button
          color="primary"
          variant="contained"
          disableElevation
          className={`${classes.registerBtn} ${classes.buttonCls}`}
          onClick={handleClick}
        >
          Create Profile Now
        </Button>
      </div>
    </FrontLayout>
  );
};

export default AgencyRegistration;
